const typographyCalendar = {
  clearFilterButton: 'Limpar'
};

export default typographyCalendar;
